import React from "react";
import { AlertCircle, CheckCircle2, Hourglass, RotateCcw, Eye } from "lucide-react";

export default function QuizSubmitSummary({ result, onRetry, onReview, canRetry }) {
    if (!result) return null;

    const isSuccess = result.success;
    const isPending = result.correctionPending;

    const icon = isPending
        ? <Hourglass size={20} />
        : isSuccess
            ? <CheckCircle2 size={20} />
            : <AlertCircle size={20} />;

    return (
        <div className={`qr-result-card ${isSuccess ? "is-success" : isPending ? "is-pending" : "is-failed"}`}>
            <div className="qr-result-header">
                {icon}
                <span>
                    {isPending
                        ? "En attente de correction"
                        : isSuccess
                            ? "Quiz réussi"
                            : "Quiz non réussi"}
                </span>
            </div>

            <div className="qr-result-body">
                <p>
                    {isPending
                        ? "Votre réponse a bien été soumise. Un correcteur la traitera prochainement."
                        : isSuccess
                            ? "Félicitations ! Vous avez atteint le seuil de réussite pour ce quiz."
                            : "Vous n'avez pas atteint le seuil de réussite. Vous pouvez relancer une tentative."}
                </p>

                <div className="qr-result-grid">
                    <div className="qr-stat-card">
                        <span>Score</span>
                        <strong>{isPending ? "--" : `${result.attempt?.score ?? "--"}%`}</strong>
                    </div>
                    <div className="qr-stat-card">
                        <span>Tentative</span>
                        <strong>#{result.attempt?.numTentative ?? "--"}</strong>
                    </div>
                    <div className="qr-stat-card">
                        <span>Restantes</span>
                        <strong>{result.attemptsRemaining ?? "0"}</strong>
                    </div>
                </div>

                <div className="qr-inline-actions">
                    {canRetry ? (
                        <button className="cr-btn cr-btn--primary" onClick={onRetry}>
                            <RotateCcw size={16} />
                            Refaire le quiz
                        </button>
                    ) : null}
                    
                    {/* Relecture masquée selon demande utilisateur */}

                    {typeof onReview === "function" ? (
                        <button className="cr-btn cr-btn--secondary" onClick={onReview}>
                            <Eye size={16} />
                            Voir la relecture
                        </button>
                    ) : null}

                </div>
            </div>
        </div>
    );
}
